import React from 'react';
import { Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import moment from 'moment';
import { isRequired } from '../../lib/forms/Validations';

import { ActiveMispari } from './';
import { InputRadioWithField } from '../../lib/forms';

let MispariFormFields = ( {translate, mispari, values, setMispariMessage, setConfirmationMispariMessage} ) => {
  if (mispari.isActiveNow) {
    setMispariMessage(translate('change-active-mispari-message'))
    setConfirmationMispariMessage(translate('confirmation-change-active-mispari-message'))
    return(
      <div>
        <div className="form-group">
            <Field activeDate={mispari.forward.stoppingDate ? mispari.forward.stoppingDate : null}  name="end" radioName="end" placeholder={translate("select-date")} label={<label>{translate('choose-date-time-of')}<strong>{` ${translate('end')} `}</strong>{translate('of-your-mispari')}</label>}  component={InputRadioWithField} type="date" min={moment()} option1={translate('now')}  validate={[ isRequired]} />
        </div>
        <div className="form-group row form-group-warning"></div>
      </div>

    )
  } else if (mispari.hasFutureMispari){
    setMispariMessage(`${translate('update-mispari-message')} `)
    setConfirmationMispariMessage(translate('confirmation-update-mispari-message'))

    let minEndDate = mispari.forward.startingDate;
    if(values && values.start) {
      if(values.start == 'option1') {
        minEndDate = moment();
      }
      else if(values.start == 'option2' && values.startField) {
        minEndDate = moment(values.startField, 'DD-MM-YYYY');
      }
    }

    return(
      <div className="card-block ">
        <Field name="start" className="form-group" hasFutureMispari={true} radioName="start" placeholder={translate("select-date")} label={translate('choose-start-date-time-mispari')} component={InputRadioWithField} option1={translate("start-now-option")} activeDate={mispari.forward.startingDate} type="date" min={moment()} validate={[ isRequired]} />
        <Field  name="end" radioName="end" hasFutureMispari={true} placeholder={translate("select-date")} label={translate('choose-end-date-time-mispari')}  component={InputRadioWithField} type="date" min={minEndDate} option1={translate("no-end-date-option")} activeDate={mispari.forward.stoppingDate ? mispari.forward.stoppingDate : null } validate={[ isRequired]} />
        <div className="form-group row mispari-border ">
          <div className="col-md-7 font-weight-bold">
            <label>{translate('do-you-want-cancel-Mispari')}</label>
          </div>
          <div className="col text-left mispari-field">
            <button className="btn btn-danger" type="button" data-target=".bd-cancelMispari-lg" data-toggle="modal"  >{translate('cancel-the-Mispari')}</button>
          </div>
        </div>
        <div className="form-group row form-group-warning">
          <div className="col">
            <small className="form-text text-muted">
              <strong>{translate('important-information')}:</strong>
              <span className="ml-1">
                {translate('important-information-message-active-mispari')}
              </span>
            </small>
          </div>
        </div>
      </div>
    )
  }
  setMispariMessage(translate('active-mispari-message'))
  setConfirmationMispariMessage(translate('confirmation-active-mispari-message'))
  return(
    <div>
      <div className="form-group">
        {ActiveMispari(mispari.wasAlreadyForwardedTo, translate, values)}
      </div>
    </div>
  )
}
const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    mispari: state.Mispari.mispari,
    values: getFormValues('mispari')(state) ,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setMispariMessage: (mispariMessage) => {
      dispatch(
        {
          type: 'SET_MISPARI_MESSAGE',
          mispariMessage: mispariMessage,
        },
      );
    },
    setConfirmationMispariMessage: (confirmationMispariMessage) => {
      dispatch(
        {
          type: 'SET_CONFIRMATION_MISPARI_MESSAGE',
          confirmationMispariMessage: confirmationMispariMessage,
        },
      );
    }
  };
};

MispariFormFields = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(MispariFormFields);

export default MispariFormFields;



// WEBPACK FOOTER //
// ./src/components/Mispari/MispariFormFields.js